import { useWC26ScoringRules } from '../../queries';
import Spinner from '../Spinner/Spinner';
import './ScoringSystemWC26.css';

const CRITERIA_LABELS: Record<string, string> = {
  t1Win: 'Team 1 Win',
  t2Win: 'Team 2 Win',
  t1Draw: 'Team 1 Draw',
  t2Draw: 'Team 2 Draw',
  redCard: 'Red Card',
  cleanSheet: 'Clean Sheet',
  ownGoal: 'Own Goal',
  goldenBoot: 'Golden Boot',
  fastestGoal: 'Fastest Goal',
  latestGoal: 'Latest Goal',
  t1WinGroup: 'Team 1 Win Group',
  t2WinGroup: 'Team 2 Win Group',
  hattrick: 'Hattrick',
  directFk: 'Direct Free Kick',
  olimpico: 'Olimpico (direct from corner)',
  keeperGoal: 'Goalkeeper Scores',
  mostReds: 'Most Red Cards in Game (must be at least 2)',
  '3+goals': 'Team Scores 3+ Goals in Game',
};

function ScoringSystemWC26() {
  const [loading, scoringRules, error] = useWC26ScoringRules();

  return (
    <div className="scoring-system-wc26">
      <h2 className="scoring-system-wc26__title">Scoring System</h2>
      {error ? <p className="scoring-system-wc26__error">Failed to load scoring rules.</p>
        : loading || !scoringRules ? <Spinner />
          : (
            <table className="scoring-system-wc26__table">
              <thead>
                <tr className="scoring-system-wc26__header-row">
                  <th className="scoring-system-wc26__header-cell">Criteria</th>
                  <th className="scoring-system-wc26__header-cell">Points</th>
                </tr>
              </thead>
              <tbody>
                {Object.entries(scoringRules).map(([criteria, points]) => (
                  <tr key={criteria} className="scoring-system-wc26__body-row">
                    <td className="scoring-system-wc26__body-cell">
                      {CRITERIA_LABELS[criteria] ?? criteria}
                    </td>
                    <td className="scoring-system-wc26__body-cell">{points}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
    </div>
  );
}

export default ScoringSystemWC26;
